import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'm-go-back',
  template: `
    <div class="m-go-back">
      <i class="m-go-back-icon" nz-icon [nzType]="mIconType" [nzTheme]="mIconTheme"></i>
      <div class="m-go-back-text" *ngIf="mShowText">{{ mText }}</div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MGoBackComponent {
  @Input() mIconType = 'left';
  @Input() mIconTheme: 'fill' | 'outline' | 'twotone' = 'outline';
  @Input() mText = '返回';
  @Input() mShowText = false;
}
